import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  quote: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  quote
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-193">
      <div className="flex space-x-1 mb-4" data-id="element-194">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-195" />)}
      </div>
      <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-196">"{quote}"</p>
      <div className="border-t border-gray-100 pt-4" data-id="element-197">
        <p className="font-semibold text-gray-900" data-id="element-198">{name}</p>
        <p className="text-sm text-gray-500" data-id="element-199">
          {role} · {location}
        </p>
      </div>
    </div>;
}